(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.controller:SearchCtrl
   *
   * @description
   *
   */
  angular
    .module('home')
    .controller('SearchCtrl', SearchCtrl);

  function SearchCtrl() {
    var vm = this;
    vm.ctrlName = 'SearchCtrl';
  }
}());
